<div *ngIf='(vm$ | async) as vm'>
    <app-page-header [vm]="vm" title='Tour Details' [canGoBack]="true" [canRefresh]="true"
        (refreshClick)="refreshPage()"></app-page-header>

    <div *ngIf="vm.tourDetails as vmtd">
        <div class="container-fluid my-3">

            <!-- Material form contact -->
            <mdb-card cascade="true" narrower="true" class="my-2">
                <!--Card content-->
                <mdb-card-body class="px-lg-5 pt-0">
                    <!-- Form -->
                    <form class="text-center" style="color: #757575;">
                        <!-- title -->
                        <div class="md-form">
                            <input type="email" id="title" class="form-control" mdbInput required [ngModel]="vmtd.title" [ngModelOptions]="{standalone: true}">
                            <label for="title">Title</label>
                        </div>
                        <div class="form-row">
                            <div class="col">
                                <!-- Start Date -->
                                <div class="md-form mt-0">
                                    <input type="date" id="startDate" class="form-control" mdbInput [ngModel]="vmtd.startDate" [ngModelOptions]="{standalone: true}">
                                    <label for="startDate">Choose tour start date</label>
                                </div>
                            </div>
                            <div class="col">
                                <!-- Last name -->
                                <div class="md-form mt-0">
                                    <input type="date" id="endDate" class="form-control" mdbInput [ngModel]="vmtd.startDate" [ngModelOptions]="{standalone: true}">
                                    <label for="endDate">Choose tour end date</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-row mt-0">
                            <div class="col">
                                <!-- City -->
                                <div class="md-form mt-0">
                                    <input type="text" id="city" class="form-control" mdbInput [ngModel]="vmtd.city" [ngModelOptions]="{standalone: true}">
                                    <label for="city">City</label>
                                </div>
                            </div>
                            <div class="col">
                                <!-- State -->
                                <div class="md-form mt-0">
                                    <input type="text" id="state" class="form-control" mdbInput [ngModel]="vmtd.state" [ngModelOptions]="{standalone: true}">
                                    <label for="state">State</label>
                                </div>
                            </div>
                            <div class="col">
                                <!-- Postal Code -->
                                <div class="md-form mt-0">
                                    <input type="text" id="postalCode" class="form-control" mdbInput [ngModel]="vmtd.postalCode" [ngModelOptions]="{standalone: true}">
                                    <label for="postalCode">Postal Code</label>
                                </div>
                            </div>
                            <div class="col">
                                <!-- Country -->
                                <div class="md-form mt-0">
                                    <input type="text" id="countryCode" class="form-control" mdbInput [ngModel]="vmtd.country" [ngModelOptions]="{standalone: true}">
                                    <label for="countryCode">Country</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-row mt-0">
                            <div class="col">
                                <!-- Booking Agent Code -->
                                <div class="md-form mt-0">
                                    <input type="text" id="bookingAgentCode" class="form-control" mdbInput>
                                    <label for="bookingAgentCode">Booking Agent Code</label>
                                </div>
                            </div>
                            <div class="col">
                                <!-- Customer Code -->
                                <div class="md-form mt-0">
                                    <input type="text" id="customerCode" class="form-control" mdbInput>
                                    <label for="customerCode">Customer Code</label>
                                </div>
                            </div>
                            <div class="col">
                                <!-- Passenger Code -->
                                <div class="md-form mt-0">
                                    <input type="text" id="passengerCode" class="form-control" mdbInput>
                                    <label for="passengerCode">Passenger Code</label>
                                </div>
                            </div>
                            <div class="col">
                                <!-- Event Code -->
                                <div class="md-form mt-0">
                                    <input type="text" id="eventCode" class="form-control" mdbInput>
                                    <label for="eventCode">Event Code</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-row mt-0">
                            <div class="col">
                                <!-- Sinage -->
                                <div class="md-form mt-0">
                                    <input type="text" id="sinage" class="form-control" mdbInput>
                                    <label for="sinage">Sinage</label>
                                    <small id="sinage" class="form-text text-muted mb-4">
                                        name sign to read
                                    </small>
                                </div>
                            </div>
                            <div class="col">
                                <!-- Vehicle Code -->
                                <div class="md-form mt-0">
                                    <input type="text" id="vehicleCode" class="form-control" mdbInput>
                                    <label for="vehicleCode">Vehicle Code</label>
                                </div>
                            </div>
                            <div class="col">
                                <!-- Vehicle Name -->
                                <div class="md-form mt-0">
                                    <input type="text" id="vehicleName" class="form-control" mdbInput>
                                    <label for="vehicleName">Vehicle Name</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-row mt-0">
                            <div class="col">
                                <!-- Billing Information -->
                                <div class="md-form mt-0">
                                    <input type="text" id="billingInformation" class="form-control" mdbInput>
                                    <label for="billingInformation">Billing Information</label>
                                </div>
                            </div>
                            <div class="col">
                                <!-- Tour Management Information -->
                                <div class="md-form mt-0">
                                    <input type="text" id="tourManagementInformation" class="form-control" mdbInput>
                                    <label for="tourManagementInformation">Tour Management Information</label>
                                </div>
                            </div>
                        </div>
                        <!-- notes -->
                        <div class="md-form mt-0">
                            <textarea type="text" id="notes" class="md-textarea md-textarea-auto form-control"
                                mdbInput></textarea>
                            <label for="notes">Notes</label>
                        </div>
                        <div class="form-row mt-0">
                            <div class="col">
                            </div>
                            <div class="col">
                                <!-- Submit button -->
                                <button mdbBtn color="info" outline="true" rounded="true" block="true"
                                    class="my-4 waves-effect z-depth-0" mdbWavesEffect type="submit">Submit</button>
                            </div>
                            <div class="col">
                                <!-- Cancel button -->
                                <button mdbBtn color="danger" outline="true" rounded="true" block="true"
                                    class="my-4 waves-effect z-depth-0" mdbWavesEffect type="button"
                                    (click)="cancel()">Cancel</button>
                            </div>
                            <div class="col">
                            </div>
                        </div>
                    </form>
                    <!-- Form -->
                </mdb-card-body>
            </mdb-card>
        </div>
    </div>
</div>